export const PHONE_NUMBER_MAX_LENGTH = {
  EG: 11,
  SA: 10
};
